import React from "react";
import './Login.css';
import authService, { AuthMode } from "./AuthService";
import config from "./config";

type LoginProperties = {
    loggedCallback: () => void
}

type LoginState = {
    username: string,
    password: string,
    authMode: AuthMode
}

class Login extends React.Component<LoginProperties, LoginState> {
    constructor(props: LoginProperties) {
        super(props);
        this.state = {
            username: "",
            password: "",
            authMode: authService.getAuthMode()
        }
    }
    private isOAuthConfigured(): boolean {
        return !!(config.OAuthProviderUrl && config.OidcClientId);
    }

    render() {
        const oauthConfigured = this.isOAuthConfigured();
        
        return (
            <div className="login">
                <h2>Login</h2>
                
                {/* OIDC Login Button - only show if OAuth is configured */}
                {oauthConfigured && (
                    <>
                        <button onClick={() => this.loginWithOidc()}>Single Sign On Login</button>
                        
                        <div style={{
                            display: 'flex', 
                            alignItems: 'center', 
                            margin: '30px 0',
                            textAlign: 'center'
                        }}>
                            <hr style={{flex: 1, border: 'none', borderTop: '1px solid #ccc'}} />
                            <span style={{padding: '0 15px', color: '#666', fontSize: '14px'}}>OR</span>
                            <hr style={{flex: 1, border: 'none', borderTop: '1px solid #ccc'}} />
                        </div>
                    </>
                )}
                
                {/* Client Credentials Form */}
                <input 
                    type="text" 
                    placeholder="Client ID" 
                    value={this.state.username} 
                    onChange={(event) => this.setState({username: event.target.value})}
                />
                <input 
                    type="password" 
                    placeholder="Client Secret" 
                    value={this.state.password} 
                    onChange={(event) => this.setState({password: event.target.value})}
                />
                <button 
                    onClick={() => this.loginWithClientCredentials()} 
                    disabled={this.state.username === "" || this.state.password === ""}
                >
                    Client Credentials Login
                </button>
            </div>
        );
    }

    private loginWithOidc = () => {
        authService.setAuthMode(AuthMode.OIDC);
        authService.login("", "", this.props.loggedCallback);
    }

    private loginWithClientCredentials = () => {
        authService.setAuthMode(AuthMode.CLIENT_CREDENTIALS);
        authService.login(this.state.username, this.state.password, this.props.loggedCallback);
    }
}

export default Login;
